// DS2 progress bar: the label and the percentage (value, 0-100) over the bar; under it the message and, with onCancel,
// a × (labelled cancelLabel, default "Cancel" in the user's language).
import cx from "classnames";
import useI18n from "../../hooks/useTranslations";
import { CrossIcon } from "./icons";
import styles from "./ProgressBar.module.css";

export type ProgressBarProps = {
  value: number;
  label?: string;
  message?: string;
  onCancel?: () => void;
  cancelLabel?: string;
  className?: string;
};

export function ProgressBar({ value, label, message, onCancel, cancelLabel, className }: ProgressBarProps) {
  const t = useI18n().translation.designSystem;
  cancelLabel ??= t.cancelLabel;
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <div className={cx(styles.progress, className)}>
      <div className={styles.top}>
        <span className={styles.label}>{label}</span>
        <span className={styles.percent}>{pct}%</span>
      </div>
      <div
        className={styles.track}
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <div className={styles.fill} style={{ width: `${pct}%` }} />
      </div>
      {message || onCancel ? (
        <div className={styles.bottom}>
          <span className={styles.message}>{message}</span>
          {onCancel ? (
            <button
              type="button"
              className={styles.cancel}
              aria-label={cancelLabel}
              title={cancelLabel}
              onClick={onCancel}
            >
              <CrossIcon />
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
